import { useSelector } from 'react-redux';
import {
  selectKycDocumentPhotoIdRequested,
  selectKycDocumentsLoaded,
  selectKycPhotoIdApproved,
} from '@/store/selectors/kycSelectors';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { envIsCanada } from '@/constants/constants';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

// This hook is used to open correct verification process for users
const useVerificationMethod = () => {
  const { openModal } = useModal();
  const photoIdApproved = useSelector(selectKycPhotoIdApproved);
  const documentsLoaded = useSelector(selectKycDocumentsLoaded);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const kycPhotoIdRequested = useSelector(selectKycDocumentPhotoIdRequested);
  const navigate = useAbsoluteNavigate();

  const openVerification = () => {
    if (
      envIsCanada() &&
      isAuthenticated &&
      documentsLoaded &&
      !photoIdApproved &&
      kycPhotoIdRequested
    ) {
      openModal(MODALS.CHECKIN_ID_SCAN, { noBackdropClick: true });
      return;
    }

    navigate('/settings/verify');
  };

  return { openVerification };
};

export default useVerificationMethod;
